'use es6';

import tinymce from 'tinymce';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ADD_AI_IMAGE_COMMAND, TRIGGER } from '../../constants/hscontentgeneration';
import { setHsContentAssistanceCommand } from '../../data/contentAssistanceAtoms';
import { updateAutocompleteQuickInsertIsActiveAtom, updateFilteredAutocompleteCommands, resetCharsOffFromResultAtom, updateAutocompleteCommandIsActiveAtom, openAutocompleteResultPopover } from '../../data/autocompleteAtoms';
import { addControls } from './controls';
import { trackInteraction } from '../../utils/usageTracking';
import { CONTENT_GENERATION_INLINE_EDIT_INTERACTION, CONTENT_GENERATION_SLASH_COMMAND_ACTION_TYPE, CONTENT_GENERATION_MENU_SELECTION, CONTENT_GENERATION_MENU_OPEN } from '../../constants/usageTracking';
import { jsx as _jsx } from "react/jsx-runtime";
const resetEditorState = () => {
  updateAutocompleteQuickInsertIsActiveAtom(false);
  updateFilteredAutocompleteCommands(null);
  resetCharsOffFromResultAtom();
  updateAutocompleteCommandIsActiveAtom(false);
};
export const handleOpenCAGenerationModal = (editor, command) => {
  setHsContentAssistanceCommand(command);
  openAutocompleteResultPopover();
};
export function getSlashCommandOptionsForInlineDropdown(editor, slashCommands) {
  const slashCommandOptions = slashCommands.map(command => {
    return {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: command.labelKey
      }),
      commandFilterPrompt: I18n.text(command.labelKey),
      id: command.id,
      onSelect: () => {
        resetEditorState();
        if (command.id === ADD_AI_IMAGE_COMMAND.id) {
          editor.fire('hsimage:openGeneratePanel');
        } else {
          handleOpenCAGenerationModal(editor, command);
        }
        trackInteraction(editor, CONTENT_GENERATION_INLINE_EDIT_INTERACTION, CONTENT_GENERATION_MENU_SELECTION, {
          actionType: CONTENT_GENERATION_SLASH_COMMAND_ACTION_TYPE,
          selected: command.id
        });
      }
    };
  });
  return slashCommandOptions;
}
export function initContentGenerationAutocompletePlugin(editor, slashCommands, brandVoiceOptions) {
  if (!slashCommands.length) return;
  const slashCommandOptions = getSlashCommandOptionsForInlineDropdown(editor, slashCommands);
  const autocompleteConfig = {
    trigger: TRIGGER,
    getFilteredCommands: text => {
      return slashCommandOptions.filter(command => command.commandFilterPrompt.toLowerCase().includes(text.toLowerCase()));
    }
  };
  tinymce.canvas.addAutocompleteCommand(editor, autocompleteConfig);
  editor.on('hsautocomplete:openPopover', () => {
    trackInteraction(editor, CONTENT_GENERATION_INLINE_EDIT_INTERACTION, CONTENT_GENERATION_MENU_OPEN, {
      actionType: CONTENT_GENERATION_SLASH_COMMAND_ACTION_TYPE
    });
  });
  addControls(editor, brandVoiceOptions);
}